import * as React from 'react';
import styled from 'styled-components';
import Button from './Button';

const FloatingIntroductoryCallButton = () => (
    <Wrapper className="z-depth-5">
        <Button large type="a" action="https://p.bttr.to/3AnSXaN">
            Book a Free Introductory Call
        </Button>
    </Wrapper>
);

export default FloatingIntroductoryCallButton;

const Wrapper = styled.div`
    position: fixed;
    bottom: 15px;
    right: 15px;
    background-color: white;
    padding: 10px;
    border-radius: 5px;
    min-width: 330px;
    z-index: 1;

    @media only screen and (max-width: 600px) {
        right: 50%;
        transform: translateX(50%);
    }
`;
